/*!
 * @pixi/mixin-get-global-position - v6.5.9
 * Compiled Wed, 25 Jan 2023 05:01:45 UTC
 *
 * @pixi/mixin-get-global-position is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
import{DisplayObject as i}from"@pixi/display";import{Point as o}from"@pixi/math";i.prototype.getGlobalPosition=function(i,t){return void 0===i&&(i=new o),void 0===t&&(t=!1),this.parent?this.parent.toGlobal(this.position,i,t):(i.x=this.position.x,i.y=this.position.y),i};
//# sourceMappingURL=mixin-get-global-position.min.mjs.map
